"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MathWalletConnector = void 0;
const Errors_1 = require("../../Errors");
const MetamaskConnector_1 = require("./MetamaskConnector");
const Types_1 = require("../../Types");
const Multicall_1 = require("../../Adapters/Multicall");
const HarmonyAdapter_1 = require("../../Blockchains/Harmony/Adapters/HarmonyAdapter");
class MathWalletConnector extends MetamaskConnector_1.MetamaskConnector {
    constructor(blockchainConfig) {
        super(blockchainConfig, {
            name: Types_1.WalletConnectors.MathWallet,
            displayName: "Mathwallet",
            isWallet: true,
        });
    }
    _connect() {
        const _super = Object.create(null, {
            _connect: { get: () => super._connect }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (this.config.blockchain !== Types_1.Blockchains.Harmony) {
                return _super._connect.call(this);
            }
            return this.connectToHarmony();
        });
    }
    connectToHarmony() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(yield this.isAvailable())) {
                throw new Errors_1.WalletNotDetectedError(this.metadata.displayName);
            }
            const chainId = this.getAgent().network.chain_id;
            if (chainId !== 1) {
                throw new Errors_1.InvalidNetworkError(chainId);
            }
            const account = yield this.getAgent().getAccount();
            const address = account.address;
            const adapter = new HarmonyAdapter_1.HarmonyAdapter(this.config);
            adapter.setAddress(address);
            adapter.setProvider(this.getAgent());
            const multicall = new Multicall_1.MulticallBaseAdapter(adapter);
            return {
                adapter,
                multicall,
            };
        });
    }
    isAvailable() {
        return __awaiter(this, void 0, void 0, function* () {
            return !!this.getAgent() && this.getAgent().isMathWallet;
        });
    }
    getAgent() {
        return this.config.blockchain === Types_1.Blockchains.Harmony
            ? window.harmony
            : window.ethereum;
    }
}
exports.MathWalletConnector = MathWalletConnector;
